import { useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { PartnerList } from './enterprise/PartnerList';
import { PartnerDetail } from './enterprise/PartnerDetail';

/**
 * Sheet content for the Enterprise SSO admin surface. Toggles between the
 * partner list and the detail tabs based on local selection state.
 *
 * Phase 3 Task 12 (the shell). Detail tabs (Overview, Admins, Identities,
 * Audit Log, Danger Zone) live in PartnerDetail (Task 19).
 */
export function EnterprisePanel(): JSX.Element {
  const [selectedPartnerId, setSelectedPartnerId] = useState<string | null>(null);

  return (
    <div className="space-y-6 overflow-y-auto h-full">
      {selectedPartnerId === null ? (
        <>
          <SheetHeader>
            <SheetTitle>Enterprise SSO</SheetTitle>
            <SheetDescription>
              Manage enterprise partners, signing-secret rotation, partner admins, and SSO identity provisioning.
            </SheetDescription>
          </SheetHeader>
          <PartnerList onSelect={setSelectedPartnerId} />
        </>
      ) : (
        <>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSelectedPartnerId(null)}
              className="-ml-2"
            >
              <ChevronLeft className="h-4 w-4 mr-1" />
              All partners
            </Button>
          </div>
          <PartnerDetail partnerId={selectedPartnerId} />
        </>
      )}
    </div>
  );
}
